import { max, min } from './Ord';
/**
 * @since 2.0.0
 */
export function getMinMaxDistributiveLattice(O) {
    return {
        meet: min(O),
        join: max(O)
    };
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/fp-ts/es6/DistributiveLattice.js
// module id = 286
// module chunks = 12